/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import {
  EuiButton,
  EuiButtonEmpty,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiOverlayMask,
  useGeneratedHtmlId,
} from '@elastic/eui'

import type { FC, ReactNode } from 'react'

type ConfirmationModalProps = {
  modalTitle: ReactNode
  cancelButtonLabel: ReactNode
  deleteButtonLabel: ReactNode
  onDeleteButtonConfirm: () => void
  onCloseConfirmModal: () => void
  content: ReactNode
}

const DestructiveActionRegularConfirmationModal: FC<ConfirmationModalProps> = ({
  modalTitle,
  cancelButtonLabel,
  deleteButtonLabel,
  onDeleteButtonConfirm,
  onCloseConfirmModal,
  content,
}: ConfirmationModalProps) => {
  const modalTitleId = useGeneratedHtmlId()

  return (
    <EuiOverlayMask>
      <EuiModal onClose={onCloseConfirmModal} role='alertdialog' aria-labelledby={modalTitleId}>
        <EuiModalHeader>
          <EuiModalHeaderTitle id={modalTitleId}>{modalTitle}</EuiModalHeaderTitle>
        </EuiModalHeader>
        <EuiModalBody>
          <p>{content}</p>
        </EuiModalBody>
        <EuiModalFooter>
          <EuiButtonEmpty onClick={onCloseConfirmModal} data-test-id='delete-text-cancel'>
            {cancelButtonLabel}
          </EuiButtonEmpty>

          <EuiButton
            onClick={onDeleteButtonConfirm}
            data-test-id='delete-text-confirm'
            fill={true}
            color='danger'
          >
            {deleteButtonLabel}
          </EuiButton>
        </EuiModalFooter>
      </EuiModal>
    </EuiOverlayMask>
  )
}

export default DestructiveActionRegularConfirmationModal
